export default __webpack_public_path__ + "static/media/Boots of Bloodlust.d7e5b487.jpg";